import React, { FunctionComponent } from 'react'
import { displaySnakeCaseAsTitleCase } from '../../../helpers/displayFormatHelper'

import { Task, DeviceFraudCheck } from '../types'

export interface Props {
  task: Task
}

const ReviewFraud: FunctionComponent<Props> = ({ task }) => {
  const { verifiables } = task
  const fraudCheck = verifiables[0] as DeviceFraudCheck
  const { externalScore, internalScore } = fraudCheck

  const rulesMatchedRow = () => {
    return fraudCheck.matches.map((rule, index) => {
      return (
        <tr className="table__row--with-border" key={index}>
          <td className="table__cell--with-border">
            {displaySnakeCaseAsTitleCase(rule.rule)}
          </td>
          <td className="table__cell--with-border">{rule.score}</td>
          <td className="table__cell--with-border" />
        </tr>
      )
    })
  }

  return (
    <div className="review-fraud">
      <h2 className="review-fraud__header">RULES MATCHED</h2>
      <table className="table">
        <tbody>
          <tr>
            <th scope="col" className="table__header">
              rule
            </th>
            <th scope="col" className="table__header">
              iovation score
            </th>
            <th scope="col" className="table__header">
              internal score
            </th>
          </tr>
          {rulesMatchedRow()}
          <tr className="table__row--with-border">
            <td className="table__cell--with-border">Total</td>
            <td className="table__cell--with-border">{externalScore}</td>
            <td className="table__cell--with-border">{internalScore}</td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}

export default ReviewFraud

ReviewFraud.displayName = 'ReviewFraud'
